require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _AppbarAction = _interopRequireDefault(require("./AppbarAction"));

var _MaterialCommunityIcon = _interopRequireDefault(require("../MaterialCommunityIcon"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Appbar/AppbarBackAction.tsx";

var AppbarBackAction = function (_React$Component) {
  (0, _inherits2["default"])(AppbarBackAction, _React$Component);

  function AppbarBackAction() {
    (0, _classCallCheck2["default"])(this, AppbarBackAction);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AppbarBackAction).apply(this, arguments));
  }

  (0, _createClass2["default"])(AppbarBackAction, [{
    key: "render",
    value: function render() {
      return React.createElement(_AppbarAction["default"], (0, _extends2["default"])({}, this.props, {
        icon: function icon(_ref) {
          var size = _ref.size,
              color = _ref.color;
          return _reactNative.Platform.OS === 'ios' ? React.createElement(_reactNative.View, {
            style: [styles.wrapper, {
              width: size,
              height: size,
              transform: [{
                scaleX: _reactNative.I18nManager.isRTL ? -1 : 1
              }]
            }],
            __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          }, React.createElement(_reactNative.Image, {
            source: require("../../assets/back-chevron.png"),
            style: [styles.icon, {
              tintColor: color
            }],
            __source: {
              fileName: _jsxFileName,
              lineNumber: 68
            }
          })) : React.createElement(_MaterialCommunityIcon["default"], {
            name: "arrow-left",
            color: color,
            size: size,
            direction: _reactNative.I18nManager.isRTL ? 'rtl' : 'ltr',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 74
            }
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        }
      }));
    }
  }]);
  return AppbarBackAction;
}(React.Component);

(0, _defineProperty2["default"])(AppbarBackAction, "displayName", 'Appbar.BackAction');
(0, _defineProperty2["default"])(AppbarBackAction, "defaultProps", {
  accessibilityLabel: 'Back'
});

var styles = _reactNative.StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: {
    height: 21,
    width: 21,
    resizeMode: 'contain'
  }
});

var _default = AppbarBackAction;
exports["default"] = _default;